module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_branded_82f25e8c28cc7b76bd206a6f27b21952.png";